import { Provider } from '@angular/core';
import { RUNS_OWN_ACTIONS, RunsOwnActions } from 'pi-ui';
import { EaDocumentationModel } from './export-assistant/ea-documentation/ea-documentation.model';
import { ProjectModel } from './project/project.model';

/** Projekty i dokumentacje asystenta eksportu wykonują akcje z menu kropek same (`runAction`). */
export const RUNS_OWN_ACTIONS_PROVIDER: Provider = {
  provide: RUNS_OWN_ACTIONS,
  useValue: (element: unknown): element is RunsOwnActions =>
    element instanceof ProjectModel || element instanceof EaDocumentationModel,
};
